var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0404 9.37377L13.5702 10.9035C13.8076 11.1409 13.8076 11.5258 13.5702 11.7632C12.2867 13.0467 10.2548 13.1911 8.80266 12.102L8.06418 11.5481C6.69501 10.5213 5.47874 9.30499 4.45187 7.93582L3.898 7.19734C2.80894 5.74525 2.95334 3.71332 4.23682 2.42985C4.47422 2.19245 4.85912 2.19245 5.09651 2.42985L6.62623 3.95956C7.01675 4.35008 7.01675 4.98325 6.62623 5.37377L6.18116 5.81884C6.07297 5.92703 6.04615 6.09231 6.11458 6.22916C6.90568 7.81137 8.18863 9.09432 9.77084 9.88542C9.90769 9.95385 10.073 9.92703 10.1812 9.81884L10.6262 9.37377C11.0168 8.98325 11.6499 8.98325 12.0404 9.37377Z",
    stroke: "#26466F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLight);
export default __webpack_public_path__ + "static/media/Phone_light.ba8d2b10cebdbe5509ce08ef66f48519.svg";
export { ForwardRef as ReactComponent };